import { typography as en } from './en';
import { typography as zh } from './zh';
import * as Types from './types';
export { Types }; // done as function to allow additional params without breaking contract (e.g. dark mode, mobile, etc)

export var getTypography = function getTypography(_ref) {
  var langKey = _ref.langKey;
  return {
    en: en,
    zh: zh
  }[langKey];
};
/**
 * @deprecated get from theme instead (language-specific)
 */

export var title = en.title;
export var headline = en.headline;
export var body = en.body;
export var tabPanel = en.tabPanel;
export var label = en.label;
export var hint = en.hint;
export var error = en.error;